import { LivePrice } from 'redux/bydaMemberLookup/types';

function formatCentsToDollars(unitAmount: number): string {
  return (unitAmount / 100).toFixed(2);
}

/** Formats cents as a dollar string e.g. "$50.00". */
export function formatCentsAsDollars(cents: number): string {
  return `$${formatCentsToDollars(cents)}`;
}

/** Formats API live price as e.g. "$50.00 AUD". */
export function formatLivePrice(livePrice: LivePrice): string {
  return `${formatCentsAsDollars(
    livePrice.unitAmount
  )} ${livePrice.currency.toUpperCase()}${
    livePrice.priceIncludeTax ? ' (inc. GST)' : ''
  }`;
}
